import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from '../../store/actions/todoActions';
import ConditionalRender from "../../components/Common/ConditionalRender";
import { ReactComponent as ArrowDownIcon } from "../../assets/icon/material-symbols_keyboard-arrow-down.svg";

function Faq() {
    const [faqData, setFaqData] = useState([]);
    const [faqLoading, setFaqLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [activeIndex1, setActiveIndex1] = useState(0);
    const [kategori, setNamaKategori] = useState("");
    const dispatch = useDispatch();

    const toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };
    const toggleAccordion1 = (index) => {
        if (activeIndex1 === index) {
            setActiveIndex1(null);
        } else {
            setActiveIndex1(index);
        }
    };

    useEffect(() => {
        fetchDataFaq();
        dispatch(isIdTarget(undefined));
    }, [dispatch]);

    const fetchDataFaq = async () => {
        setFaqLoading(true);
        try {
            const response = await ApiService({
                baseurl: "user/faq",
                method: "GET",
                XGORDON: "FAQ"
            });
            setFaqLoading(false);
            if (response?.statusCode === 200) {
                setFaqData(response.result.data);
            } else {
                setFaqData([]);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-3xl  text-[#22BDE2] font-bold">Pusat Bantuan 
                        dan FAQ</span>
                    <span className=" text-base font-light ">
                        Kami siap membantu kendala yang kamu alami, silahkan pilih pertanyaan sesuai dengan masalahmu.
                    </span>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/Faq.gif')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 max-h-72 h-full" />
                </div>
            </div>
            <div className="flex flex-col p-3 gap-2 lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark  min-h-[100px] relative">
                <span className="text-2xl font-bold text-center ">FAQ</span>
                <div className=" grid grid-cols-2 sm:grid-cols-3 p-1 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6  gap-2  overflow-hidden bg-cardLight dark:bg-cardDark relative">
                    <ConditionalRender
                        productsData={faqData}
                        isLoading={faqLoading}
                        model={"emptyData"}
                    >
                        {faqData.map((item, index) => {
                            return (
                                <div key={index} className="flex flex-col ">
                                    <button className={`flex p-3 h-full flex-row justify-between items-center rounded-lg ${activeIndex !== index ? ' text-lightColor' : 'bg-[#22BDE2] text-darkColor'} shadow-inner`}
                                        onClick={() => {
                                            toggleAccordion(index)
                                            setNamaKategori(item.kategori)
                                        }}>
                                        {/* <div
                                            dangerouslySetInnerHTML={{ __html: item.kategori }}
                                            className={` text-base line-clamp-1 text-center`}
                                        /> */}
                                        <span className="font-normal text-center flex flex-1 justify-center">{item.kategori}</span>
                                    </button>

                                </div>
                            )
                        })}
                    </ConditionalRender>
                </div>
            </div>
            {kategori !== "" &&
                <div className="flex flex-col lg:rounded-lg rounded-none shadow-inner bg-cardLight dark:bg-cardDark gap-2 sm: min-h-[100px] p-3">
                    <div className="flex flex-row gap-2 items-center">
                        <span className="text-2xl font-bold text-center text-[#22BDE2]">FAQ</span>
                        <span className="text-md text-center text-[#929292]">{">>"}</span>
                        <span className="text-2xl font-bold text-center text-[#22BDE2]">{kategori}</span>

                    </div>
                    <ConditionalRender
                        productsData={faqData}
                        isLoading={faqLoading}
                        model={"emptyData"}
                    >
                        {faqData.map((item, index) => {
                            return (
                                activeIndex === index && (
                                    <div key={index} className="flex py-3 flex-col gap-2 "
                                    >
                                        {faqData[index].faq.map((item, index) => {
                                            return (
                                                <div key={index} className="flex flex-col">
                                                    <button className={`flex p-3 bg-[#22BDE2] flex-row justify-between items-center rounded-t-lg ${activeIndex1 !== index && 'rounded-b-lg'}`}
                                                        onClick={() => toggleAccordion1(index)}>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: item.pertanyaan }}
                                                            className={` text-base line-clamp-1  text-darkColor`}
                                                        />
                                                        <ArrowDownIcon fill="#212121" className={`-rotate-90 ${activeIndex1 === index && '-rotate-0'}`} />
                                                    </button>
                                                    {activeIndex1 === index && (
                                                        <div className="flex p-3  flex-row justify-start gap-2 items-center bg-cardLight dark:bg-cardDark rounded-b-lg shadow-inner"
                                                        >
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: item.jawaban }}
                                                                className={` text-base text-left pl-0 pb-0`}
                                                            />
                                                        </div>)}
                                                </div>
                                            )
                                        })}
                                    </div>)
                            )
                        })}
                    </ConditionalRender>
                </div>
            }
        </div>
    );
}

export default Faq;
